import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { UpgradeStaffMemberFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface UpgradeStaffMemberFormProps {
  defaultFormValues?: Partial<UpgradeStaffMemberFormValues>;
  children?: React.ReactNode;
}
export const UpgradeStaffMemberForm = ({
  defaultFormValues,
  children,
}: UpgradeStaffMemberFormProps) => {
  const methods = useForm<UpgradeStaffMemberFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
